import sdk from '@cognite/cdf-sdk-singleton';

export type ErrorResponse = { message?: string };

export default sdk;
